import {
  fetchDoctorProfilesList,
  fetchPatientProfilesList,
  fetchPharmacyProfilesList
} from './careRecords';

/**
 * Overview counts from care API (GET-only). Failing endpoints count as 0.
 * @param {string} token
 */
export async function getOverviewMetrics(token) {
  if (!token) {
    return {
      doctorsCount: 0,
      patientsCount: 0,
      pharmaciesCount: 0
    };
  }

  const [doctors, patients, pharmacies] = await Promise.all([
    fetchDoctorProfilesList(token).catch(() => []),
    fetchPatientProfilesList(token).catch(() => []),
    fetchPharmacyProfilesList(token).catch(() => [])
  ]);

  return {
    doctorsCount: doctors.length,
    patientsCount: patients.length,
    pharmaciesCount: pharmacies.length
  };
}
